import { start } from '@jutro/app';
import { BrandingService } from '@xengage/gw-portals-branding-js';
import appConfig from 'app-config';
import { LocaleService, G11nstore } from 'gw-portals-i18n-react';
import { BrowserRouter } from 'react-router-dom';
import 'regenerator-runtime';
import { getConfigValue } from '@jutro/config';
import { Loader } from '@jutro/components';
import { configureLegacyComponentMap } from '@jutro/legacy/uiconfig';
import { initDefaultGAEnt } from 'gw-platform-events-js'
import CustomLoader from './components/CustomLoader/CustomLoader';
import App from './app/App';

configureLegacyComponentMap();

export const startApp = scriptAttributes => {

    const silentRedirectPath = appConfig?.authentication?.servers?.okta?.JUTRO_AUTH_SILENT_REDIRECT_PATH;
    const silentLoginPath = appConfig?.authentication?.servers?.okta?.JUTRO_AUTH_SILENT_LOGIN_PATH;

    if (window.self === window.top) {
        const theBody = document.getElementsByTagName('body')[0];

        theBody.style.display = 'block';
    } else if ((!silentLoginPath || !window.self.location.pathname.endsWith(silentLoginPath)) && (!silentRedirectPath || !window.self.location.pathname.endsWith(silentRedirectPath))) {
        const { host, protocol } = new URL(window.top.location);
        const root = `${protocol}//${host}`;
        const rootPath = process.env.PUBLIC_PATH;

        window.top.location = new URL(rootPath, root);
    }

    const {
        trackingConfig = {},
        authentication = {},
        microFrontendsConfig = {},
        policyTransactionMicroAppConfig = {},
    } = appConfig;

    const gaTrackingId = trackingConfig.GA_TRACKING_ID || appConfig.GA4_TRACKING_ID;

    if (gaTrackingId) {
        initDefaultGAEnt();
    }

    Loader.defaultProps = {
        renderLoader: CustomLoader
    }

    const config = {
        ...authentication.servers.okta,
        ...policyTransactionMicroAppConfig,
        ...{ microFrontendsConfig },
        ...appConfig.credentials,
    };

    // DE17226 enable redirected logout on okta failure callback
    const url = new URL(window.location.toString());
    const error = url.searchParams.get('error');
    if (error == 'access_denied') {
        const loginErrorRedirectUrl = getConfigValue('LOGIN_ERROR_REDIRECT_URL', appConfig.enterpriseLoginErrorURL);
        window.location.href = loginErrorRedirectUrl;
    }

    start(App, {
        rootId: 'root',
        themeConfig: BrandingService.getBrandingTheme(),
        messageLoader: LocaleService.loadMessages,
        coreMessageLoader: LocaleService.loadCoreMessages,
        refreshOnLanguageOrLocaleChange: true,
        routerBasename: '/producer-engage',
        config: [config],
        g11nStore: G11nstore(),

        onInit: () => {
            LocaleService.register();
        },

        Router: BrowserRouter,

        appName: {
            id: 'digital.appName',
            defaultMessage: 'ProducerEngage',
        },

        appDescription: 'ProducerEngage',
        disableAuthForApplicationRoot: true,
        mfeData: { scriptAttributes },
    });
};
